export enum ClaimBudgetStatusEnum {
  Opened = 1,
  Unauthorized = 2,
  Authorized = 3,
}